import { render, staticRenderFns } from "./Reval.vue?vue&type=template&id=724e53a8"
import script from "./Reval.vue?vue&type=script&lang=js"
export * from "./Reval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports